var map = {
	"./locale-da.js": 972,
	"./locale-de.js": 973,
	"./locale-en.js": 974,
	"./locale-es.js": 975,
	"./locale-fr.js": 976,
	"./locale-id.js": 977,
	"./locale-it.js": 978,
	"./locale-pl.js": 979,
	"./locale-pt.js": 980,
	"./locale-ru.js": 981,
	"./locale-sv.js": 982,
	"./locale-zh.js": 983
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 971;